const Vue = window.Vue;
const VueRouter = require('vue-router').default;

const transactionContractRouter = new VueRouter({
    routes: [
        {
            name: 'transaction-contract-entry',
            path: '/',
            redirect: { name: 'transaction-contract-user-is-korgoo' },
        },
        {
            name: 'transaction-contract-user-is-korgoo',
            path: '/user-is-korgoo',
            component: require('./components/pages/transaction-contract/List.vue').default,
            props: { activeUserSide: 'KORGOO' }
        },
        {
            name: 'transaction-contract-user-is-haigoo',
            path: '/user-is-haigoo',
            component: require('./components/pages/transaction-contract/List.vue').default,
            props: { activeUserSide: 'HAIGOO' }
        },
        {
            name: 'transaction-contract-view',
            path: '/view/:id',
            component: require('./components/pages/transaction-contract/View.vue').default,
        },
        {
            name: 'transaction-contract-dispute',
            path: '/dispute/:id/:type',
            component: require('./components/pages/transaction-contract/Dispute.vue').default,
            props: {
                isDisputing: true
            }
        },
        {
            name: 'transaction-contract-change-status',
            path: '/change-status/:id',
            component: require('./components/pages/transaction-contract/ChangeStatus.vue').default,
        },
        {
            name: 'transaction-contract-change-status-form',
            path: '/change-status-form/:id',
            component: require('./components/pages/transaction-contract/ChangeStatusForm.vue').default,
        },
        {
            name: 'transaction-contract-edit-land-detail-form',
            path: '/edit-land-detail-form/:id',
            component: require('./components/pages/transaction-contract/EditLandDetailForm.vue').default,
        },
    ],
})

Vue.component('transaction-contract-app', require('./components/pages/transaction-contract/Index.vue').default)

if ($('#transaction-contract-app').length) { // for transaction-contract-app
    const app = new Vue({
        router: transactionContractRouter
    }).$mount('#transaction-contract-app');
}